import { Toast} from 'vant';
import Vue from 'vue';
import {  Image as VanImage,Popup ,Dialog,Button,field,form} from 'vant';
Vue.use(VanImage);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(field);
Vue.use(form);
Vue.prototype.$toast = Toast;